import { initializeApp } from 'firebase/app';
import { getAuth, browserSessionPersistence } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCdQF5lrTjEsnooERe2PyPgw032rvJpdkk',
  authDomain: 'bonum-admins.firebaseapp.com',
  projectId: 'bonum-admins',
  storageBucket: 'bonum-admins.appspot.com',
  messagingSenderId: '879077123868',
  appId: '1:879077123868:web:f855313d42bacfbd1d7cd9',
};

export function translateFirebaseErrors(firebaseError) {
  let message = '';
  switch (firebaseError) {
    case 'auth/wrong-password': {
      message = 'La contraseña es incorrecta';
      break;
    }

    case 'auth/user-not-found': {
      message = 'El usuario no existe';
      break;
    }

    default: {
      message = 'Error, contacte al administrador';
      break;
    }
  }

  return message;
}

// Initialize Firebase
const app = initializeApp(firebaseConfig, 'service__admin');
const auth = getAuth(app);
// BT-1452: some corporate networks kill Firestore's gRPC-over-WebChannel
// stream ("client is offline" / ERR_CONNECTION_CLOSED) even though the SDK
// (v11) already defaults `experimentalAutoDetectLongPolling` to true -- the
// autodetect probe itself was failing on those networks. Forcing long
// polling sidesteps the probe entirely. The cost is irrelevant here: this
// app does a single getDoc per session and has no realtime listeners.
const firestore = initializeFirestore(app, { experimentalForceLongPolling: true });
const storage = getStorage(app);

const setAuthPersistence = async () => {
  try {
    await auth.setPersistence(browserSessionPersistence);
  } catch (error) {
    console.error(error);
  }
};

export { auth, firestore, storage, setAuthPersistence };
